<template>
<div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && Object.keys(orderItems).length == 0">
        {{$t('table.no_records')}}
    </div>
    <div v-if="!isSpinnerShow && Object.keys(orderItems).length != 0" class="dataTables_wrapper dt-bootstrap4">
        <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
            <div class="col-sm-12 overflow-auto">
                <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                    <thead class="thead-themed">
                        <tr>
                            <th v-for="tblHeader in fields" :key="tblHeader.key">
                                {{tblHeader.label}}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(items, l ) in orderItems" :key="l">
                        <tr class="dtrg-group dtrg-start">
                            <td colspan="11" class="text-capitalize fs-md border-top-bottom-2">
                                <span class="mr-2 fw-700">{{l+1}}.</span>
                                <span class="mr-1">Receipt#</span>
                                <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(items.salesID, false)">
                                    {{insertLeadingZero(items.receiptID)}}
                                    <i class="fal fa-print"></i>
                                </a>
                            </td>
                        </tr>
                        <tr v-for="(item, i) in items.items" :key="i">
                            <td style="width: 10%;" :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">{{getDateTime(items.createDate)}}</td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">{{getOutletName(items.outletID)}}</td>
                            <td class="align-middle" >
                                <div v-if="item.staffs.length == 0">-</div>
                                <div v-for="staff in item.staffs" :key="staff.staffID">
                                    {{staff.name}} <br>
                                </div>
                            </td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">{{items.member.displayName}}</td>
                            <td style="width: 12%;" :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">
                                <a class="link text-primary" title="Send Receipt via WhatsApp" @click="sendReceipt(items.salesID, items.member.mobile)"><i class=" fab fa-whatsapp mr-1"></i>{{items.member.mobile}}</a>
                            </td>
                            <td class="align-middle"><span class="badge border border-primary text-primary mr-2">{{item.qty}} x</span>{{item.title}}</td>
                            <td style="width: 10%;" class="align-middle" v-b-tooltip.hover.right :title="getTooltipMessage(item.redeem)">
                                <span v-if="item.redeem == 'credits'" class="badge badge-warning">C</span>
                                <span v-else-if="item.redeem == 'package'" class="badge badge-success">P</span>
                                <span v-else class="badge badge-primary">S</span>
                                {{parseFloat(item.price).toFixed(2)}}
                            </td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle text-capitalize">
                                <div v-for="item in items.payment" :key="item.paymentTypeID">
                                    {{item.paymentMethod}}<span v-if="item.paymentAmount != '-'" class="text-secondary fw-300 ml-1">[{{parseFloat(item.paymentAmount).toFixed(2)}}]</span><br>
                                </div>
                            </td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">{{parseFloat(item.tax.tax).toFixed(2)}}</td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle">{{parseFloat(item.rounding).toFixed(2)}}</td>
                            <td :rowspan="items.items.length" v-if="items.items.length - i == items.items.length" class="align-middle fw-500">
                                {{getPaymentAmount(items.payment).total}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <modal ref="modal" @performConfirmAction="performAction"></modal>
</div>
</template>
<script>
import Modal from './../../Delete_Modal'
import _ from 'lodash';
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import exp from './../../../../assets/js/dashboard/export-table-header'
import {insertLeadingZero} from './../../../../assets/js/dashboard/utilities.js'
import {getOutletName, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'orderList',
    components:{
        Modal
    },
    data(){
        return{
            tblHeaders: tbl.orderTblHdr,
            orderItems: {}, outlet: [], isSpinnerShow: false,
            salesID: "", mobile: "",
            filterObj: {}
        }
    },
    computed:{
        fields(){
            return[
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "outlet", label: this.$i18n.t('table.header.outlet')},
                {key: "staff", label: this.$i18n.t('table.header.staff')},
                {key: "infoName", label: this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('table.header.name')},
                {key: "mobile", label: this.$i18n.t('table.header.contact')},
                {key: "item", label: this.$i18n.t('table.header.item')},
                {key: "amount", label: this.$i18n.t('table.header.amount')},
                {key: "paymentMethod", label: this.$i18n.t('table.header.payment_method')},
                {key: "tax", label: this.$i18n.t('table.header.tax')},
                {key: "rounding", label: this.$i18n.t('table.header.rounding')},
                {key: "total", label: this.$i18n.t('table.header.total', {'item': ''})}, 
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.receipt_number')).toUpperCase()] = "receiptNumber"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.staff')).toUpperCase()] = "staffs"
            ret[(this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('table.header.name')).toUpperCase()] = "infoName"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.header.item')).toUpperCase()] = "items"
            ret[(this.$i18n.t('table.header.payment_method')).toUpperCase()] = "paymentMethod"
            ret[(this.$i18n.t('table.header.rounding')).toUpperCase()] = "rounding"
            ret[(this.$i18n.t('table.header.total',{'item': ''})).toUpperCase()] = "total"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.orderItems, this.filterObj)
        }
    },
    methods:{
        getPaymentAmount(items){
            var obj = {
                total: 0,
                paymentMethod: []
            }
            for(var i=0; i<items.length; i++){
                obj.total += items[i].paymentAmount
                obj.paymentMethod.push(
                    items[i].paymentMethod.charAt(0).toUpperCase() + items[i].paymentMethod.slice(1)
                )
            }
            obj.total = parseFloat(obj.total).toFixed(2)
            return obj
        },
        getTooltipMessage(redeem){
            return redeem == "" ? "Sales" : "Redeem by " + redeem.charAt(0).toUpperCase() + redeem.slice(1) 
        },
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        getDateTime(ts){
            return moment(ts*1000).format('DD/MM/YYYY HH:mm:ss')
        },
        setOrderItems(items, filterObj){
            var group = _.groupBy(items, "receiptID")
            for(var r in group){
                var result = group[r].reduce((unique, o) => {
                    if(!unique.some(obj => obj.item.itemID === o.item.itemID)) {
                        o.qty = 1
                        unique.push(o);
                    }else{
                        var i = unique.findIndex(x => x.item.itemID === o.item.itemID);
                        unique[i].qty += 1
                    }
                    return unique;
                },[]);
                group[r] = result
            } 
            for(var g in group){
                var obj = {
                    createDate: group[g][0].createDate,
                    outletID: group[g][0].outletID,
                    salesID: group[g][0].salesID,
                    receiptID:  group[g][0].receiptID,
                    voidDate: group[g][0].voidDate,
                    member: group[g][0].member,
                    items: [],
                    payment: group[g][0].payment
                }
                var arrItems = [];
                for(var i=0; i<group[g].length; i++){
                    arrItems.push({
                        qty: group[g][i].qty,
                        itemID: group[g][i].item.itemID,
                        title: group[g][i].item.title,
                        type: group[g][i].item.type,
                        category: group[g][i].item.category,
                        price: group[g][i].price - group[g][i].discount - group[g][i].outstandings,
                        redeem: group[g][i].redeem,
                        staffs: group[g][i].staffs,
                        tax: group[g][i].tax,
                        rounding: group[g][i].rounding,
                    })
                }
                obj.items = arrItems
                group[g] = obj
            }

            this.isSpinnerShow = false;
            this.orderItems = _.orderBy(group, ['createDate'], ['desc'])
            this.filterObj = filterObj
            this.setExportData(this.orderItems, filterObj)
        },
        setExportData(group, filterObj){
            var exportData = []
            for(var k = 0; k<group.length; k++){
                var pObj = this.getPaymentAmount(group[k].payment)
                var obj = {
                    index: k + 1,
                    date: this.getDateTime(group[k].createDate),
                    receiptNumber: this.insertLeadingZero(group[k].receiptID),
                    outlet: this.getOutletName(group[k].outletID),
                    infoName: group[k].member.displayName,
                    mobile: group[k].member.mobile,
                    paymentMethod: pObj.paymentMethod.join(),
                    total: pObj.total
                }
                obj = this.setExpotDataOrderItems(group[k].items, obj)
                exportData.push(obj)
            }
            
            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_order`) 
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_order`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : filterObj.outlet.text),
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },
        setExpotDataOrderItems(items, obj){
            var arrItems = []; var arrStaffs = []
            for(var i=0; i<items.length; i++){
                var redeem = items[i].redeem == "" ? "" : "[Redeem by " + items[i].redeem.charAt(0).toUpperCase() + items[i].redeem.slice(1) + "]"
                arrItems.push(items[i].title + " x" + items[i].qty) + " " + redeem 
                if(items[i].staffs.length == 0){
                    arrStaffs.push("-")
                }else{
                    for(var j=0; j<items[i].staffs.length; j++){
                        arrStaffs.push(items[i].staffs[j].name)
                    }
                }
                
                obj.tax = parseFloat(items[i].tax.tax).toFixed(2)
                obj.rounding= parseFloat(items[i].rounding).toFixed(2)
            }
            obj.items = arrItems.join()
            obj.staffs = arrStaffs.join()
            return obj
        },
        sendReceipt(salesID, mobile){
            this.salesID = salesID
            this.mobile = mobile
            var title = this.$i18n.t('header.generate_receipt')
            var message = this.$i18n.t('message.confirmation.generate_receipt', {'mobile': mobile})
            this.$refs.modal.showModal(title, message)
        },
        performAction(){
            this.generateReceipt(this.salesID, true)
            this.$refs.modal.toggleModal = false
        },
        generateReceipt(salesID, isWA){
            const QUERY_STRING = "/" + salesID + this.$api.RECEIPT
            const url =  this.$api.REPORT_SALES + QUERY_STRING;

            let $vm = this
            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                if(response.status == 200){
                    var path = !isWA ? response.data.path : $vm.$api.API_WA + $vm.mobile + "?text=Please find your e-receipt here: " + response.data.path
                    window.open(path, '_blank');
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        },
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>